/*eslint-disable*/
import React, {useEffect} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import useBasePage from "../hooks/useBasePage";
import {validateField} from "../utils/validation";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router";
export default function (
    ComposedComponent,
    mapStatetoProps,
    actionCreators,
    {requestInitialData, pageTrackingConfig = {}, getPageType = () => {}},
) {
    const ReduxContainer = (props) => {
        const {location, globalLayoutProps} = props;
        const pageObj = getPageType(location.pathname);
        const dispatchHook = useDispatch();
        const historyHook = useHistory();
        useBasePage(
            location,
            globalLayoutProps,
            validateField(pageObj, "object", "activePage") ? pageObj.activePage : "",
            pageTrackingConfig,
        );
        return (
            <ComposedComponent {...props} dispatchHook={dispatchHook} historyHook={historyHook} />
        );
    };

    class ContextConnectedReduxContainer extends React.Component {
        constructor(props) {
            super(props);
            const {dispatch} = props;
            this.boundActionCreators = bindActionCreators(actionCreators, dispatch);
        }
        static requestInitialData = (checkReturnData = false, extraParams = {}) => {
            return requestInitialData(checkReturnData, extraParams);
        };

        render() {
            return <ReduxContainer {...this.props} {...this.boundActionCreators} />;
        }
    }
    return connect(mapStatetoProps)(ContextConnectedReduxContainer);
}
